// Debug flag - set to true to enable debug logging
var KLAVIYO_DEBUG = true;

// Popup Enable/Disable flag - set to true to enable Klaviyo popups
var KLAVIYO_POPUPS_ENABLED = true;

// Popup cooldown in milliseconds (e.g., 30 minutes = 30 * 60 * 1000)
var KLAVIYO_POPUP_COOLDOWN = 30 * 60 * 1000;

/**
 * Helper to check if a specific popup ID is currently in cooldown
 * @param {string} popupId
 * @returns {boolean}
 */
function isPopupInCooldown(popupId) {
  if (!popupId) return false;
  try {
    var lastShown = localStorage.getItem('klaviyo_last_shown_' + popupId);
    if (!lastShown) return false;
    
    var now = Date.now();
    var timePassed = now - parseInt(lastShown, 10);
    
    var inCooldown = timePassed < KLAVIYO_POPUP_COOLDOWN;
    
    if (KLAVIYO_DEBUG && inCooldown) {
      console.log(`[Klaviyo Logic] Popup ${popupId} is in cooldown. ${Math.round((KLAVIYO_POPUP_COOLDOWN - timePassed) / 1000)}s remaining.`);
    }
    
    return inCooldown;
  } catch (e) {
    return false;
  }
}

/**
 * Helper to record that a popup was shown
 * @param {string} popupId
 */
function recordPopupShown(popupId) {
  if (!popupId) return;
  try {
    localStorage.setItem('klaviyo_last_shown_' + popupId, Date.now().toString());
  } catch (e) {
    // Ignore storage errors
  }
}

var productDefinitions = {
  'vent': { type: 'Vent', isGateway: false, isVent: true, isPro: false, isDeprecated: false },
  'bridge': { type: 'Bridge', isGateway: true, isVent: false, isPro: false, isDeprecated: false },
  'bridge-pro': { type: 'Bridge', isGateway: true, isVent: false, isPro: true, isDeprecated: false },
  'puck': { type: 'Puck', isGateway: true, isVent: false, isPro: false, isDeprecated: true },
  'puck-pro': { type: 'Puck', isGateway: true, isVent: false, isPro: true, isDeprecated: true },
  'puck-2': { type: 'Puck', isGateway: true, isVent: false, isPro: false, isDeprecated: false },
  'puck-2-pro': { type: 'Puck', isGateway: true, isVent: false, isPro: true, isDeprecated: false },
  '24vac-transformer': { type: 'Accessory', isGateway: false, isVent: false, isPro: false, isDeprecated: false },
  'usb-wall-plate': { type: 'Accessory', isGateway: false, isVent: false, isPro: false, isDeprecated: false },
  'smart-vent-cover': { type: 'Accessory', isGateway: false, isVent: false, isPro: false, isDeprecated: false },
  'static-pressure-kit': { type: 'Accessory', isGateway: false, isVent: false, isPro: true, isDeprecated: false },
};

function hasProductTypeInCart(cart, type) {
  if (!cart || (typeof cart !== 'object' && !Array.isArray(cart))) return false;
  
  // Handle different cart structures
  let items = [];
  if (Array.isArray(cart)) {
    items = cart;
  } else if (cart.items && Array.isArray(cart.items)) {
    items = cart.items;
  }
  
  if (!items.length) return false;
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log(`[Klaviyo Logic] hasProductTypeInCart checking for type '${type}' in cart:`,
      items.map(item => ({ handle: item.handle, title: item.title, type: productDefinitions[item.handle]?.type })));
  }
  
  const result = items.some(item => {
    const definition = productDefinitions[item.handle];
    return definition && definition.type === type;
  });
  
  if (KLAVIYO_DEBUG) {
    console.log(`[Klaviyo Logic] hasProductTypeInCart result for type '${type}':`, result);
  }
  
  return result;
}

function hasGatewayInCart(cart) {
  if (!cart || (typeof cart !== 'object' && !Array.isArray(cart))) return false;
  
  // Handle different cart structures
  let items = [];
  if (Array.isArray(cart)) {
    items = cart;
  } else if (cart.items && Array.isArray(cart.items)) {
    items = cart.items;
  }
  
  if (!items.length) return false;
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasGatewayInCart checking cart:',
      items.map(item => ({ handle: item.handle, title: item.title, isGateway: productDefinitions[item.handle]?.isGateway })));
  }
  
  const result = items.some(item => {
    const definition = productDefinitions[item.handle];
    return definition && definition.isGateway;
  });
  
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasGatewayInCart result:', result);
  }
  
  return result;
}

function hasVentInCart(cart) {
  if (!cart || (typeof cart !== 'object' && !Array.isArray(cart))) return false;
  
  // Handle different cart structures
  let items = [];
  if (Array.isArray(cart)) {
    items = cart;
  } else if (cart.items && Array.isArray(cart.items)) {
    items = cart.items;
  }
  
  if (!items.length) return false;
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasVentInCart checking cart:',
      items.map(item => ({ handle: item.handle, title: item.title, isVent: productDefinitions[item.handle]?.isVent })));
  }
  
  const result = items.some(item => {
    const definition = productDefinitions[item.handle];
    return definition && definition.isVent;
  });
  
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasVentInCart result:', result);
  }
  
  return result;
}

function hasPuckInCart(cart) {
  if (!cart || (typeof cart !== 'object' && !Array.isArray(cart))) return false;
  
  // Handle different cart structures
  let items = [];
  if (Array.isArray(cart)) {
    items = cart;
  } else if (cart.items && Array.isArray(cart.items)) {
    items = cart.items;
  }
  
  if (!items.length) return false;
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasPuckInCart checking cart:',
      items.map(item => ({ handle: item.handle, title: item.title, type: productDefinitions[item.handle]?.type })));
  }
  
  const result = items.some(item => {
    const definition = productDefinitions[item.handle];
    return definition && definition.type === 'Puck';
  });
  
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasPuckInCart result:', result);
  }
  
  return result;
}

function hasBridgeInCart(cart) {
  if (!cart || (typeof cart !== 'object' && !Array.isArray(cart))) return false;
  
  // Handle different cart structures
  let items = [];
  if (Array.isArray(cart)) {
    items = cart;
  } else if (cart.items && Array.isArray(cart.items)) {
    items = cart.items;
  }
  
  if (!items.length) return false;
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasBridgeInCart checking cart:',
      items.map(item => ({ handle: item.handle, title: item.title, type: productDefinitions[item.handle]?.type })));
  }
  
  const result = items.some(item => {
    const definition = productDefinitions[item.handle];
    return definition && definition.type === 'Bridge';
  });
  
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] hasBridgeInCart result:', result);
  }
  
  return result;
}

function isWholesaleCustomer(customerTags) {
  if (!customerTags) return false;
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] isWholesaleCustomer checking tags:', customerTags);
  }
  
  const result = customerTags.includes('wholesale');
  
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] isWholesaleCustomer result:', result);
  }
  
  return result;
}

function isProductInCart(cart, productHandle) {
  if (!cart || (typeof cart !== 'object' && !Array.isArray(cart)) || !productHandle) return false;

  // Handle different cart structures
  let items = [];
  if (Array.isArray(cart)) {
    items = cart;
  } else if (cart.items && Array.isArray(cart.items)) {
    items = cart.items;
  }
  
  if (!items.length) return false;

  if (KLAVIYO_DEBUG) {
    console.log(`[Klaviyo Logic] isProductInCart checking for '${productHandle}' in cart:`,
      items.map(item => ({ handle: item.handle, title: item.title })));
  }

  const result = items.some(item => item.handle === productHandle);

  if (KLAVIYO_DEBUG) {
    console.log(`[Klaviyo Logic] isProductInCart result for '${productHandle}':`, result);
  }

  return result;
}

window.getKlaviyoPopupId = function getKlaviyoPopupId(cart, productHandle, productTitle, customerTags, selectedOptionText) {
  // Check if popups are globally disabled
  if (!KLAVIYO_POPUPS_ENABLED) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Popups are globally disabled, returning null');
    }
    return null;
  }
  
  // Debug logging
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] getKlaviyoPopupId called with:', {
      productHandle: productHandle,
      productTitle: productTitle,
      customerTags: customerTags,
      selectedOptionText: selectedOptionText,
      cart: cart,
      cartType: typeof cart,
      cartIsArray: Array.isArray(cart),
      cartItems: cart && Array.isArray(cart) ? cart.map(item => ({ handle: item.handle, title: item.title })) : (cart && cart.items ? cart.items.map(item => ({ handle: item.handle, title: item.title })) : null),
      shopifyCart: window.Shopify && window.Shopify.cart,
      globalCart: window.cart
    });
    
    // Check if Shopify.cart exists globally
    if (!window.Shopify || !window.Shopify.cart) {
      console.warn('[Klaviyo Logic] WARNING: Shopify.cart is not available globally!');
      console.log('[Klaviyo Logic] Shopify object keys:', Object.keys(window.Shopify || {}));
    }
    
    // Check if cart parameter is null/undefined
    if (cart === null || cart === undefined) {
      console.error('[Klaviyo Logic] ERROR: cart parameter is null/undefined!');
      console.log('[Klaviyo Logic] Call stack:', new Error().stack);
    }
  }

  // Check if cart is null and try to fetch it
  if (!cart || cart === null || cart === undefined) {
    if (KLAVIYO_DEBUG) {
      console.warn('[Klaviyo Logic] Cart is null/undefined, trying to fetch cart data...');
    }
    
    // Try to fetch cart data if ensureShopifyCart is available
    if (typeof window.ensureShopifyCart === 'function') {
      window.ensureShopifyCart()
        .then(fetchedCart => {
          cart = fetchedCart;
          if (KLAVIYO_DEBUG) {
            console.log('[Klaviyo Logic] Successfully fetched cart data:', cart);
          }
          // Re-run the logic with the fetched cart
          return getKlaviyoPopupId(cart, productHandle, productTitle, customerTags, selectedOptionText);
        })
        .catch(error => {
          if (KLAVIYO_DEBUG) {
            console.error('[Klaviyo Logic] Failed to fetch cart data:', error);
          }
          // Return null if we can't get cart data
          return null;
        });
      
      // Since this is async, we need to return null for now
      // The async call will handle the actual logic
      return null;
    } else {
      if (KLAVIYO_DEBUG) {
        console.warn('[Klaviyo Logic] ensureShopifyCart function not available');
      }
      // Return null if no cart data and no way to fetch it
      return null;
    }
  }
  
  // TODO: Remove popup skip - Comment this line to enable the popup logic
  // return null;

  function isVent(optionText) {
    if (!optionText) return false;
    return optionText.includes('x') && !optionText.includes('/');
  }

  const currentProductDefinition = productHandle ? productDefinitions[productHandle] : null;

  // If the product is already in the cart, do not show the popup
  if (productHandle && isProductInCart(cart, productHandle)) {
    if (KLAVIYO_DEBUG) {
      console.log(`[Klaviyo Logic] Product '${productHandle}' already in cart, returning null.`);
    }
    return null;
  }

  /**
   * Internal helper to handle cooldown check and recording
   * @param {string} id
   * @returns {string|null}
   */
  function processPopupId(id) {
    if (!id) return null;
    
    if (isPopupInCooldown(id)) {
      return null;
    }
    
    recordPopupShown(id);
    return id;
  }
   
  // Default - only return T85EYj for pro instances, otherwise return null
  if (currentProductDefinition && currentProductDefinition.isPro) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering default condition for pro product, returning T85EYj');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('T85EYj');
  }

  // Specific Product Handles / Options
  if (productHandle === '24vac-transformer' && !isWholesaleCustomer(customerTags)) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering 24vac-transformer condition, returning WVD4ZW');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('WVD4ZW');
  }
  if (productHandle === 'usb-wall-plate') {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering usb-wall-plate condition, returning WRX4HP');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('WRX4HP');
  }
  if (productHandle === 'smart-vent-cover') {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering smart-vent-cover condition, returning UDRUvK');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('UDRUvK');
  }

  // B2C Popup Notification - Bridge Pro ATC
  if (productHandle === 'bridge-pro' && currentProductDefinition && currentProductDefinition.isPro && !isWholesaleCustomer(customerTags)) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering Bridge Pro product restriction, returning WkSESQ');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('WkSESQ');
  }

  // B2C Popup Notification - Vent + Bridge (No Puck)
  if (
      currentProductDefinition &&
      // is adding a vent or a bridge
      (currentProductDefinition.type === 'Vent' || currentProductDefinition.type === 'Bridge')
      // already have a vent or a bridge
      && (hasVentInCart(cart) || hasBridgeInCart(cart))
      // don't have a puck in their cart already
      && !hasPuckInCart(cart)
    ) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering vent+gateway!puck combination, returning XJPBzQ');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('XJPBzQ');
  }

  // B2C Popup Notification - Puck + Vent (No Bridge)
  if (
      currentProductDefinition &&
      // is adding a puck or a vent
      (currentProductDefinition.type === 'Puck' || currentProductDefinition.type === 'Vent')
      // already have a puck or a vent
      && (hasPuckInCart(cart) || hasVentInCart(cart))
      // don't have a bridge in their cart already
      && !hasBridgeInCart(cart)
    ) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering puck+vent!gateway combination, returning Ut4vX3');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('Ut4vX3');
  }
  // B2C Popup Notification - Puck Only (No Bridge)
  if (
      currentProductDefinition &&
      // is adding a puck
      currentProductDefinition.type === 'Puck'
      // don't have a bridge in their cart already
      && !hasBridgeInCart(cart)
    ) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering puck only (no bridge/vent) combination, returning S7qk7w');
    }
    if (isProductInCart(cart, productHandle)) return null;
    return processPopupId('S7qk7w');
  }

  // B2C Popup Notification - Vent Only (No Bridge, No Puck)
  // Also covers cases where selectedOptionText indicates a vent
  if (
    (currentProductDefinition && currentProductDefinition.type === 'Vent' || isVent(selectedOptionText)) &&
    // doesn't have a bridge in the cart
    !hasBridgeInCart(cart) &&
    // doesn't have a puck in the cart
    !hasPuckInCart(cart)
  ) {
    if (KLAVIYO_DEBUG) {
      console.log('[Klaviyo Logic] Triggering vent only (no bridge/puck) combination, returning VGnmcY');
    }
    if (productHandle && isProductInCart(cart, productHandle)) return null; // Only check if product exists
    return processPopupId('VGnmcY');
  }
  
  if (KLAVIYO_DEBUG) {
    console.log('[Klaviyo Logic] Triggering default condition for non-pro product, returning null');
  }
  return null;
}

/**
 * Initialize Centralized Add to Cart and Klaviyo Click Handling
 */
document.addEventListener('click', function(event) {
  const button = event.target.closest('.product-form__klaviyo');
  if (!button) return;

  const productHandle = button.dataset.productHandle;
  const productTitle = button.dataset.productTitle;
  const customerTagsData = button.dataset.customerTags || '';
  const customerTags = customerTagsData.toLowerCase().split(',').map(t => t.trim());
  const isDistributor = button.dataset.isDistributor === 'true';
  const isProOnly = button.dataset.isProOnly === 'true';

  if (KLAVIYO_DEBUG) {
    console.warn('[Klaviyo Logic] ATC Button Clicked:', {
      productHandle,
      productTitle,
      customerTags,
      isDistributor,
      isProOnly
    });
  }

  // 1. Distributor Restriction with SWAL2
  if (isDistributor) {
    event.preventDefault();
    event.stopImmediatePropagation();
    
    if (typeof window.showDistributorPopup === 'function') {
      window.showDistributorPopup();
    } else {
      // Fallback if the function isn't globally available yet for some reason
      if (typeof Swal !== 'undefined') {
        Swal.fire({
          title: 'Distributor Account',
          text: 'Distribution purchases must be made through your assigned account manager or our dedicated wholesale ordering channel. Thank you for your continued partnership.',
          icon: 'info',
          confirmButtonColor: '#000',
          confirmButtonText: 'I Understand'
        });
      } else {
        alert('As a distributor, please place your orders through your assigned account manager or our dedicated wholesale ordering channel.');
      }
    }
    return;
  }

  // 2. Klaviyo Popup Logic
  let klaviyoIdAttr = button.dataset.klaviyoId;

  // Map placeholder 'pro-only' to effective Klaviyo ID
  if (klaviyoIdAttr === 'pro-only') {
    klaviyoIdAttr = 'T85EYj';
  }

  if (klaviyoIdAttr || isProOnly) {
    if (isProOnly) {
      event.preventDefault();
    }
    
    if (klaviyoIdAttr) {
      if (KLAVIYO_DEBUG) {
        console.warn('[Klaviyo Logic] opening Klaviyo form from attribute/map:', klaviyoIdAttr);
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', klaviyoIdAttr]);
      return;
    }
  }

  // Fallback to calculation if no attribute
  // Attempt to find the select element to get the selected variant title (for vent checks)
  let option = null;
  const selectors = [
    'select[name="id"]',
    '.select__select',
    'input[name="id"]'
  ];
  
  const form = button.closest('form');
  if (form) {
    for (let selector of selectors) {
      option = form.querySelector(selector);
      if (option) break;
    }
  }

  let selectedOptionText = '';
  if (option) {
    if (option.tagName === 'SELECT') {
      selectedOptionText = option.options[option.selectedIndex] ? option.options[option.selectedIndex].text : '';
    } else if (option.tagName === 'INPUT') {
      selectedOptionText = option.value;
    }
  }

  // Call the existing getKlaviyoPopupId
  if (typeof window.getKlaviyoPopupId === 'function') {
    const cartData = (window.Shopify && window.Shopify.cart) ? window.Shopify.cart : (window.cart || null);
    
    // If cart is missing, we might want to wait or fetch it, but usually this happens on click
    const popupId = window.getKlaviyoPopupId(cartData, productHandle, productTitle, customerTagsData, selectedOptionText);
    
    if (popupId) {
      if (KLAVIYO_DEBUG) {
        console.log('[Klaviyo Logic] Opening Klaviyo form (calculated):', popupId);
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', popupId]);
    }
  }
});

/**
 * Global function to show the Distributor Restriction Popup
 */
window.showDistributorPopup = function() {
  if (typeof Swal !== 'undefined') {
    Swal.fire({
      title: 'Distributor Account',
      text: 'Distribution purchases must be made through your assigned account manager or our dedicated wholesale ordering channel. Thank you for your continued partnership.',
      icon: 'info',
      confirmButtonColor: '#000',
      confirmButtonText: 'I Understand'
    });
  } else {
    alert('As a distributor, please place your orders through your assigned account manager or our dedicated wholesale ordering channel.');
  }
};